module.exports = __webpack_public_path__ + "9c92e0c5c4ead743082b04978b1b9ce9.pdf";